import { EnvironmentService } from '@/services/environment';
import {
  captureException,
  init,
  reactRouterV7BrowserTracingIntegration,
  wrapCreateBrowserRouterV7,
  type BrowserOptions,
} from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';
import { createBrowserRouter } from 'react-router-dom';

const options: BrowserOptions = {
  dsn: 'https://6b916b2490634b36a5434c31d23c5797@o372675.ingest.us.sentry.io/5896648',
  integrations: [
    reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
};

export const SentryService = {
  init: (config: BrowserOptions = {}) => {
    // @ts-ignore
    const isProd = process.env.NODE_ENV === 'production';
    // @ts-ignore
    const release = process.env.RELEASE_NAME;

    if (isProd && release) {
      EnvironmentService.getEnvironment().then((environment) => {
        if (environment === 'stage' || environment === 'production') {
          init({
            ...options,
            ...config,
            environment,
            release,
          });
        }
      });
    }
  },
  trackError: captureException,
  sentryCreateBrowserRouter: wrapCreateBrowserRouterV7(createBrowserRouter),
};
